import './BlogPostSkeletonCard.scss';

const BlogPostSkeletonCard = () => {
  return (
    <div className="blogPostSkeletonCard">
      <div className="thumb"></div>
      <div className="title"></div>
      <div className="category"></div>
      <div className="date"></div>
      <div className="author">
        <div className="authorImage"></div>
        <div className="authorName"></div>
      </div>
      <div className="editIconContainer"></div>
      <div className="deleteIconContainer"></div>
    </div>
  );
};

export default BlogPostSkeletonCard;
